import { THEME_UI_DEFAULT_KEY } from './types'

export default function (
  x: unknown
): x is { [THEME_UI_DEFAULT_KEY]: string | number } {
  return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x
}
